import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
// @ts-expect-error Untyped import
import DateCell from '../cells/DateCell';
// @ts-expect-error Untyped import
import UserCell from '../cells/UserCell';
import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TagManagerTableRow = ({
  tag
}) => {
  const tagName = tag.get('name');
  const color = tag.get('color');
  const createdBy = tag.get('createdBy');
  const createdAt = tag.get('createdAt');
  if (!tagName || !color || !createdBy || !createdAt) {
    return null;
  }
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx(TableHoverCell, {
      hoverContent: /*#__PURE__*/_jsxs(TFlex, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reports.tagManager.table.actions.edit"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reports.tagManager.table.actions.delete"
          })
        })]
      }),
      children: /*#__PURE__*/_jsxs(TFlex, {
        alignItems: "center",
        gap: 8,
        children: [/*#__PURE__*/_jsx(ColorSwatch, {
          color: color,
          size: 6
        }), /*#__PURE__*/_jsx(TruncateString, {
          tooltip: true,
          children: tagName
        })]
      })
    }), /*#__PURE__*/_jsx(UserCell, {}), /*#__PURE__*/_jsx(DateCell, {
      timestamp: createdAt
    })]
  });
};
export default TagManagerTableRow;